<template>
  <v-card>
    <v-toolbar dark dense flat :color="toolbarColor">

      <v-toolbar-title :class="titleClass">{{ formTitle }}</v-toolbar-title>

      <v-spacer />
      
      <!-- OK / Cancel -->
      <v-toolbar-items>
        <v-btn
          dark
          :color="toolbarColorDark"
          @click="cancel"
          class="elevation-0"
          >
          {{ getExpression('Button', 'Cancel') }}
        </v-btn>
        <v-btn
          dark
          :color="toolbarColorDark"
          @click="select"
          class="elevation-0 ml-2"
          :disabled="mediaPathTypeId < 0"
          >
          {{ getExpression('Button', 'OK') }}
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    
      <v-alert
        outlined
        class="pa-2 mx-1 mt-1 mb-0"
        >
        <template v-slot:prepend>
          <v-icon>info_outlined</v-icon>
        </template>
        <span>{{ longDescription }}</span>
      </v-alert>

    <v-card-text class="mt-0 pt-0">
      <v-radio-group v-model="mediaPathTypeId">
        <v-radio
          v-for="pt in mediaPathTypes"
          :key="pt.id"
          :value="pt.id"
          :color="appColor_Selected"
          >
          <template v-slot:label>
            <span>{{ pt.description }}</span>
            <template v-if="isKiosk">
              <v-icon v-if="getPathTypeStatus(pt)" small :color="appColor_Selected" class="ml-2">done</v-icon>
              <v-icon v-else small :color="appColor_Error" class="ml-2">cancel</v-icon>
            </template>
          </template>
        </v-radio>
      </v-radio-group>

      <v-img :src="selectedImageUri" max-width="220"></v-img>
    </v-card-text>
  </v-card>
</template>

<script>
import { AppColor, MediaPathTypeId, ImageUri } from '@/config.js'

export default {
  name: 'AbbyPlaylistSelector',
  props: {
    title: {
      type: String,
      default: null
    },
    mediaPathTypes: {
      type: Array,
      default: null
    },
    mediaPathStatuses: {
      type: Array,
      default: null
    },
    defaultPathTypeId: {
      type: Number,
      default: null
    },
    isKiosk: {
      type: Boolean,
      default: true
    },
    toolbarColor: {
      type: String,
      default: AppColor.Medium
    },
    toolbarColorDark: {
      type: String,
      default: AppColor.Dark
    }
  },
  data() {
    return {
      // colors
      appColor_Selected: AppColor.Selected,
      appColor_Error: AppColor.Error,

      // images
      imageUri_None: ImageUri.AbbyPanelNone,
      imageUri_Ambient: ImageUri.AbbyPanelAmbient,
      imageUri_Radio: ImageUri.AbbyPanelRadio,
      imageUri_SlideShow: ImageUri.AbbyPanelSlideShow,
      imageUri_TV: ImageUri.AbbyPanelTV,
      imageUri_Cat: ImageUri.AbbyPanelCat,
      imageUri_Wheel: ImageUri.AbbyPanelWheel,

      // path type ids
      pathTypeId_Ambient: MediaPathTypeId.VideosAmbient,
      pathTypeId_Music: MediaPathTypeId.AudioMusic,
      pathTypeId_Images: MediaPathTypeId.ImagesGeneral,
      pathTypeId_TV: MediaPathTypeId.VideosTV,
      pathTypeId_Cats: MediaPathTypeId.VideosPetCat,
      pathTypeId_TurnWheel: MediaPathTypeId.VideosTurnWheel,

      mediaPathTypeId: this.defaultPathTypeId !== null ? this.defaultPathTypeId : -1
    }
  },
  computed: {
    formTitle () {
      return this.title !== null
        ? this.title
        : this.getExpression('FormTitle', 'SelectPlaylist')
    },
    selectedImageUri () {
      switch(this.mediaPathTypeId) {
        case this.pathTypeId_Ambient:
          return this.imageUri_Ambient
        case this.pathTypeId_Music:
          return this.imageUri_Radio
        case this.pathTypeId_Images:
          return this.imageUri_SlideShow
        case this.pathTypeId_TV:
          return this.imageUri_TV
        case this.pathTypeId_Cats:
          return this.imageUri_Cat
        case this.pathTypeId_TurnWheel:
          return this.imageUri_Wheel          
        default:
          return this.imageUri_None
      }
    },
    longDescription () {
      if (this.mediaPathTypeId <= 0) 
        return this.getExpression('Alert', 'SelectAbbyPlaylistText')

      const self = this
      const pathTypes = self.mediaPathTypes.filter(pt => pt.id === self.mediaPathTypeId)
      return pathTypes.length > 0
        ? `Manage ${this.decapitalizeFirstLetter(pathTypes[0].longDescription)}`
        : null
    },
    titleClass () {
      return !this.isSmallDevice
        ? 'body-1'
        : 'body-2'
    }
  },
  methods: {
    cancel () {
      this.$emit('cancel')
    },

    select () {
      const mediaPathTypeId = this.mediaPathTypeId
      this.$emit('select', mediaPathTypeId)
    },

    getPathTypeStatus(item) {
      if (this.mediaPathStatuses === null) return ''
      const statuses = this.mediaPathStatuses.filter(s => s.id === item.id)
      return statuses.length > 0
        ? statuses[0]?.hasMedia ?? false
        : false
    },

    decapitalizeFirstLetter(s) {
      return s.charAt(0).toLowerCase() + s.slice(1);
    }
  }
}
</script>